import React from 'react';
import { /*NavLink,*/ Redirect, Route, useHistory } from 'react-router-dom';
import { ConfirmedPage } from '../..';
import './style.css';
const Index = () => {
    const hist = useHistory();
    return (
        <div className="manage_orders">
            <div className="manage_orders_head">
                <h2>MANAGE ORDERS</h2>
                <div className="manage_orders_head_right">
                    <button style={{ marginRight: '2rem' }} className="btn-gray">
                        Download
                    </button>
                    <button
                        onClick={() => {
                            hist.push('/main/newOrder');
                        }}
                        className="btn-orange"
                    >
                        New Order
                    </button>
                </div>
            </div>
            {/* <nav className="manage_order_navigation">
                <NavLink
                    className="manage_order_navigation_item"
                    activeClassName="active"
                    to="/main/manageOrders/confirmed"
                >
                    Confirmed
                </NavLink>
                <NavLink
                    className="manage_order_navigation_item"
                    activeClassName="active"
                    to="/main/manageOrders/unconfirmed"
                >
                    UnConfirmed
                </NavLink>
                <NavLink
                    className="manage_order_navigation_item"
                    activeClassName="active"
                    to="/main/manageOrders/returns"
                >
                    Returns
                </NavLink>
            </nav> */}
            <div className="manage_order_content">
                <Route path="/main/manageOrders/all" exact>
                    <ConfirmedPage />
                </Route>
                <Route path="/main/manageOrders/unconfirmed" exact>
                    <div>Unconfirmed</div>
                </Route>
                <Route path="/main/manageOrders/returns" exact>
                    <div>Returns</div>
                </Route>
                <Redirect to="/main/manageOrders/all" />
            </div>
        </div>
    );
};

export default Index;
